<template>
    <div
        class="selected"
        data-selected-bar
        style="position: sticky; bottom: 0px"
    >
        <div class="selected-header">
            <div class="container selected-header-content">
                <h2 class="selected-heading mb-0">
                    Wybrano:
                    <span>{{ typeWord }}</span>
                </h2>

                <div class="d-block d-lg-flex mt-3 mt-lg-0 align-items-center">
                    <button
                        @click="$store.dispatch('selectAllSettlements', false)"
                        class="btn btn-danger"
                    >
                        <span>Wyczyść zaznaczone</span>
                    </button>
                    <span class="dropup">
                        <the-btn
                            class="btn btn-secondary ml-3"
                            id="dropdownDownloadNotes"
                            data-toggle="dropdown"
                            text="Pobierz"
                            icon="Download"
                            @click.native="showDropdown = !showDropdown"
                            v-click-outside="hideDropdown"
                        >
                            <a-icon icon="Dropdown" />
                        </the-btn>
                        <div
                            class="
                                dropdown-menu
                                dropdown-menu-right
                                dropdown-menu-bottom
                            "
                            :class="{ show: showDropdown }"
                            aria-labelledby="dropdownDownloadNotes"
                        >
                            <button
                                v-if="activeTab !== 2"
                                class="dropdown-item"
                                type="button"
                                @click="downloadSettlements(`Report`)"
                            >
                                Raporty rozliczeniowe - xls
                            </button>
                            <button
                                class="dropdown-item"
                                type="button"
                                @click="downloadSettlements(`Note`)"
                            >
                                Dokumenty księgowe - pdf
                            </button>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDropdown: false
        }
    },
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    computed: {
        typeWord() {
            return this.$options.filters.plurals(
                this.selectedSettlementsCount,
                'dokument',
                'dokumenty',
                'dokumentów'
            )
        },
        selectedSettlementsCount() {
            return this.$store.getters.getSelectedSettlementsCount
        },
        activeTab() {
            return this.$store.getters.getSettlementsActiveTab
        }
    },
    methods: {
        downloadSettlements(bundleType) {
            this.$store.dispatch('downloadSettlements', {
                bundleType: bundleType
            })
        },
        hideDropdown() {
            this.showDropdown = false
        }
    }
}
</script>
